
import { defineComponent } from "vue";
import SupplyInput from "@/modules/tokens/components/tokensSupplyInputComponent.vue";
import store from '@/store/index';
import qrcode from 'qrcode-generator';
import TokenService from "@/services/TokenService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";
import tokensConfirmCreateTokenModal from "@/modules/tokens/components/modals/tokensConfirmCreateTokenModal.vue";
import { AccountHttp, Address, AggregateTransaction, Convert, Deadline, MosaicDefinitionTransaction, MosaicId, MosaicMetadataTransaction, MosaicNonce, MosaicProperties, MosaicSupplyChangeTransaction, MosaicSupplyType, PublicAccount, UInt64 } from "tsjs-xpx-chain-sdk";
import { Peer } from "peerjs";

export default defineComponent({
  name: 'tokensCreateAssetFormComponent',
  props: {
    isInsufficientBalance: Boolean,
  },
  components: {
    SupplyInput,
    tokensConfirmCreateTokenModal,
  },

  data: function () {
    return {
      network: '',
      imageFile: "",
      fileName: "",
      previewImage: "",
      tokenName: "",
      tokenSymbol: "",
      selectedTokenName: "",
      selectedTokenSymbol: "",
      isMultisig: false,
      userData: store.getters['auth/user'] ?? "",
      jwtToken: store.getters['auth/jwtToken'] ?? "",
      mainnetJwtToken: store.getters['auth/mainnetJwtToken'] ?? "",
      selectedTokenType: "IGT",
      assetId: 'Fetching asset ID...',
      supply: '',
      supplyPlaceholder: '0',
      decimal: 0,
      publicKey: '',
      mosaicNonce: null,
      qr: '',
      isQRModalShow: false,
      isDisplayUploadTokenImageLabel: false,
      isDisabledModalConfirmSubmitButton: false,
      showUploadingLoader: false,
      selectedTokenDivisibility: 0,
      maxValue: '9999999999999', // length - 13
      defaultMaxValue: '9999999999999', // length - 13
    };
  },

  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },

    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        // this.isDisplaySaveTokenImageOptions = true;
      }
    },

    revertTokenImage(){
      this.isDisplayUploadTokenImageLabel = false;
      this.$refs.fileInput.value = null;
      this.previewImage = '';
    },

    updateTokenImage() {
      this.isDisplayUploadTokenImageLabel = false;
    },

    updateSupply(){
      this.maxValue = '9'.repeat(13-this.selectedTokenDivisibility) + (this.selectedTokenDivisibility>0?'.':'') + '9'.repeat(this.selectedTokenDivisibility);
      this.supplyPlaceholder = parseFloat('0').toFixed(this.selectedTokenDivisibility);
      this.supply = '';
    },

    updateTokenType(){
      if(this.selectedTokenType =='LET'){
        this.maxValue = this.defaultMaxValue;
      }else if(this.selectedTokenType == 'IGT'){
        this.maxValue = '9'.repeat(13-this.selectedTokenDivisibility) + (this.selectedTokenDivisibility>0?'.':'') + '9'.repeat(this.selectedTokenDivisibility);
      }
    },

    createTokenQr() {
      if (this.userData !== "" && this.jwtToken !== "") {
        const publicAcc = PublicAccount.createFromPublicKey(this.publicKey, this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']);
        let mosaicTxn :MosaicDefinitionTransaction;
        let mosaicSupplyTxn :MosaicSupplyChangeTransaction;

        let xarcadeHex = Convert.utf8ToHex('xarcade');
        let xarcadeHexData = xarcadeHex + "00".repeat((16-xarcadeHex.length)/2)

        let xarcadeValue = {
          name:this.tokenName,
          symbol:this.tokenSymbol,
          type:this.selectedTokenType
        }

        let xarcadeMetadataTxn = MosaicMetadataTransaction.create(
          Deadline.create(),
          publicAcc,
          new MosaicId(this.assetId),
          UInt64.fromHex(xarcadeHexData),
          JSON.stringify(xarcadeValue),
          '',
          this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
        )
        if(this.selectedTokenType=='IGT'){
          mosaicTxn= MosaicDefinitionTransaction.create(
            Deadline.create(),
            this.mosaicNonce,
            new MosaicId(this.assetId),
            MosaicProperties.create({
              supplyMutable: true,
              transferable: true,
              divisibility: this.selectedTokenDivisibility,
              duration: undefined
            }),
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
          mosaicSupplyTxn = MosaicSupplyChangeTransaction.create(
            Deadline.create(),
            new MosaicId(this.assetId),
            MosaicSupplyType.Increase,
            this.selectedTokenDivisibility==0?UInt64.fromUint(Math.trunc(parseFloat(this.supply.replace(",", "")) )):UInt64.fromUint(Math.trunc(parseFloat(this.supply.replace(",", "")) * Math.pow(10, this.selectedTokenDivisibility) ))  ,
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
        }else if(this.selectedTokenType =='LET'){
          mosaicTxn= MosaicDefinitionTransaction.create(
            Deadline.create(),
            this.mosaicNonce,
            new MosaicId(this.assetId),
            MosaicProperties.create({
              supplyMutable: false,
              transferable: true,
              divisibility: 0,
              duration: undefined
            }),
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
          mosaicSupplyTxn = MosaicSupplyChangeTransaction.create(
            Deadline.create(),
            new MosaicId(this.assetId),
            MosaicSupplyType.Increase,
            UInt64.fromUint(Math.trunc(parseFloat(this.supply.replace(",", "")))),
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
        }else if(this.selectedTokenType =='NFT'){
          this.supply = 1;
           mosaicTxn= MosaicDefinitionTransaction.create(
            Deadline.create(),
            this.mosaicNonce,
            new MosaicId(this.assetId),
            MosaicProperties.create({
              supplyMutable: false,
              transferable: true,
              divisibility: 0,
              duration: undefined
            }),
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
          mosaicSupplyTxn = MosaicSupplyChangeTransaction.create(
            Deadline.create(),
            new MosaicId(this.assetId),
            MosaicSupplyType.Increase,
            UInt64.fromUint(1),
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']
          )
        }
        let innerTxn = [
          mosaicTxn.toAggregate(publicAcc),
          mosaicSupplyTxn.toAggregate(publicAcc),
          xarcadeMetadataTxn.toAggregate(publicAcc),
        ]
        let aggregateTxn :AggregateTransaction
        if(this.isMultisig){
          aggregateTxn = AggregateTransaction.createBonded(
            Deadline.create(),
            innerTxn,
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType'],
            []
          )
        }else{
          aggregateTxn = AggregateTransaction.createComplete(
            Deadline.create(),
            innerTxn,
            this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType'],
            []
          )
        }

        const peer = new Peer();
        peer.on("open", (id) => {
          const qrCode = qrcode(0, 'H');
          let data = {
            payload:aggregateTxn.serialize(),
            type:'sign',
            recvId: peer.id,
            generationHash:this.network=='Testnet'?this.$store.getters['config/getTestnetGenerationHash']:this.$store.getters['config/getMainnetGenerationHash'],
            callbackUrl: null
          }
          qrCode.addData(JSON.stringify(data));
          qrCode.make();
          this.qr = qrCode.createSvgTag({scalable: true})
        });

        peer.on("connection", (conn) => {
          // console.log("connected to " + conn.peer);
          conn.on("data", (data: any) => {
            conn.send("success");
          });
        });
        this.isQRModalShow = true;
      }
    },

    async initAssetId() {
      let accountHttp = new AccountHttp(this.network=='Testnet'?store.getters['config/getTestnetApi']:store.getters['config/getMainnetApi']);
      this.publicKey = this.network=='Testnet'?this.userData.testnetPublicAddress:this.userData.mainnetPublicAddress;
      let nonce = MosaicNonce.createRandom();
      this.mosaicNonce = nonce;
      this.assetId = MosaicId.createFromNonce(this.mosaicNonce, PublicAccount.createFromPublicKey(this.publicKey, this.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType'])).id.toHex();

      let multisigInfo = await accountHttp.getMultisigAccountInfo(Address.createFromRawAddress(this.network=='Testnet'?this.userData.testnetWalletAddress:this.userData.mainnetWalletAddress)).toPromise()
      this.isMultisig = multisigInfo.cosignatories.length>0?true:false;
    },

    createToken(){
      if (this.userData !== "" && this.jwtToken !== "") {
        this.isDisabledModalConfirmSubmitButton = true;
        this.showUploadingLoader = true;
        let data = new FormData();
        data.append("userId", this.userData.userId);
        data.append("assetId", this.assetId);

        if (this.tokenName !== "") {
          data.append("title", this.tokenName);
          data.append("symbol", this.tokenSymbol);
          data.append("type", this.selectedTokenType);

          if (this.imageFile !== "") {
            data.append("logoStream", this.imageFile[0]);
          }

          TokenService.createToken(data, this.network=='Testnet'?this.jwtToken:this.mainnetJwtToken, this.network=='Testnet'?'testnet':'mainnet')
            .then((response: ResponseData) => {
              this.isQRModalShow = false;
              this.showUploadingLoader = false;
              this.isDisabledModalConfirmSubmitButton = false;
              Helper.toastSuccessHandling(response.data['message']);
              this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
              this.$router.push("/tokens");
            })
            .catch((error) => {
              this.isDisabledModalConfirmSubmitButton = false;
              this.showUploadingLoader = false;
              Helper.endpointErrorHandling(error);
            });
        } else {
          this.isDisabledModalConfirmSubmitButton = false;
          this.showUploadingLoader = false;
          Helper.endpointErrorHandling('', 'Token name is empty!');
        }
      }
    },

    addTokenNameAndSymbol() {
      this.selectedTokenName = this.tokenName;
      this.selectedTokenSymbol = this.tokenSymbol;
    },

    updateOnboardingChecklist(userId: string, jwtToken: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, jwtToken)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, this.network=='Testnet'?6:10, userId, jwtToken);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },
  },

  computed:{
    disableCreate(){
      if(!this.isInsufficientBalance && this.publicKey){
        if(this.selectedTokenType=='NFT'){
          return this.tokenName.trim() == '' || this.tokenSymbol.trim()==''
        }else{
          return this.tokenName.trim() == '' || this.tokenSymbol.trim()=='' || parseFloat(this.supply) <= 1 ||  isNaN(parseFloat(this.supply)) 
        }
      }else{
        return true;
      }
    },
    testnet2ApkVersion() {
      return store.getters['config/getTestnet2MobileApkVersion'];
    },
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
  },

  mounted() {
    this.network = Helper.capitalizeFirstLetter(this.$route.params.network);
    this.initAssetId();
  },
});
